import { render, staticRenderFns } from "./EditarInformacionAdmin.vue?vue&type=template&id=0ec776f1&"
import script from "./EditarInformacionAdmin.vue?vue&type=script&lang=js&"
export * from "./EditarInformacionAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports